import Vue from 'vue';

import template from './subscribe.html';

const buttonStates = [
  { state: 'wait', text: 'Submit' },
  { state: 'fetch', text: 'Submitting...' },
  { state: 'success', text: 'Submitted!' },
  { state: 'error', text: 'Whoops, error' },
];

Vue.component('subscribe', {
  template,
  data: function () {
    return {
      buttonStates,
      buttonState: buttonStates[0],
      showRequired: false,
      firstName: '',
      lastName: '',
      email: '',
    };
  },
  methods: {
    onInput: function () {
      // Right now only using this when email changes
      // so we can encourage unique emails
      this.showRequired = false;
      this.buttonState = this.buttonStates[0];
    },

    subscribe: function ($event) {
      // If they've already signed up, break
      if(this.buttonState.state === 'success') return;

      if (!this.firstName || !this.lastName || !this.email) {
        this.showRequired = true;
        return;
      }

      const URL = '';
      const body = new FormData($event.target);

      this.buttonState = buttonStates[1];

      fetch(URL, {
        method: 'POST',
        mode: 'no-cors',
        body,
      })
      .then(() => this.buttonState = buttonStates[2])
      .catch(err => this.buttonState = buttonStates[3]);
    }
  },
});



// WEBPACK FOOTER //
// ./src/components/subscribe/subscribe.js